import { Text } from './Text'
import './system.css'

export function Progress({
  value,
  max,
  label,
  caption,
  steps = false,
}: {
  value: number
  max: number
  label: string
  caption?: string
  steps?: boolean
}) {
  const percent = Math.min(100, Math.max(0, (value / max) * 100))
  const done = Math.min(max, Math.max(0, value))

  return (
    <div className="progress">
      <div
        className={steps ? 'progress__track progress__track--steps' : 'progress__track'}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-label={label}
      >
        {steps ? (
          Array.from({ length: max }, (_, index) => (
            <span
              key={index}
              className={index < done ? 'progress__step progress__step--done' : 'progress__step'}
            />
          ))
        ) : (
          <div className="progress__fill" style={{ width: `${percent}%` }} />
        )}
      </div>
      {caption ? (
        <Text role="caption" tone="muted">
          {caption}
        </Text>
      ) : null}
    </div>
  )
}
